import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';

import Button, { ButtonStyles } from '@Components/Buttons/Button';
import { showSearchResultsModal } from '@Components/Modal/modalHelpers';
import { Messages } from '@Config/messages';
import { AdvertFragment } from '@Graphql/graphqlTypes.generated';
import { useTranslations } from '@Hooks/useTranslations';

import styles from './MapPreviewButton.module.scss';

export interface MapPreviewButtonProps {
  edges: AdvertFragment[] | undefined;
  filterData: Record<string, any>;
}

const MapPreviewButton: FunctionComponent<MapPreviewButtonProps> = ({ edges, filterData }) => {
  const t = useTranslations();
  const dispatch = useDispatch();

  const onPreviewInMap = () => {
    dispatch(showSearchResultsModal(edges || [], filterData));
  };

  return (
    <div className={styles.container}>
      <Button
        style={ButtonStyles.regular}
        label={t(Messages.btnPreviewInMap)}
        disabled={!edges}
        onClick={onPreviewInMap}
      />
    </div>
  );
};

export default MapPreviewButton;
